<template>
<div>
  <el-table
    v-loading="users == null"
    @row-click="openDialog"
    :height="windowHeight - 210"
    :data="users">
    <el-table-column
      label="Name"
      :fixed="$mq === 'xs' ? false : 'left'"
      sortable
      prop="firstName"
      min-width="150">
      <template slot-scope="scope">
        {{ getFullName(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column
      label="Class"
      :fixed="$mq === 'xs' ? false : 'left'"
      sortable
      prop="level.o_id"
      align="center"
      min-width="100">
      <template slot-scope="scope">
        {{ scope.row.level.name }}
      </template>
    </el-table-column>
    <el-table-column
      label="Username"
      sortable
      prop="un"
      min-width="115">
    </el-table-column>
    <el-table-column
      label="Position"
      sortable
      prop="primary_position"
      min-width="300">
      <template slot-scope="scope">
        {{ scope.row.primary_position != null ? scope.row.primary_position.name : ' '}}
      </template>
    </el-table-column>
  </el-table>
    <el-dialog
      :title="(selectedUser ? getFullName(selectedUser) : '') + '\'s Inventory'"
      :visible.sync="userDialogVisible"
      @close="closeDialog"
      :fullscreen="true"
    >
    <nxs-user-inventory :userId="selectedUser ? selectedUser.o_id : null"></nxs-user-inventory>
    </el-dialog>
</div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import nxsUserInventory from './UserInventory.vue';

export default {
    components: {nxsUserInventory},
    props: ['selected_update'],
    computed: {
        ...mapFields([
            'user',
            'users'
        ])
    },
    data() {
        return {
            searchList: [],
            userDialogVisible: false,
            selectedUser: null
        };
    },
    methods: {
        openDialog(user) {
            this.selectedUser = user;
            this.userDialogVisible = true;
        },
        closeDialog() {
            if(this.userDialogVisible)
                this.userDialogVisible = false;
            this.selectedUser = null;
        }
    }
}
</script>
